import { Product_Info } from '@/globalcfg.js';


const en = {
    messages: {
      'number_particle': 'Number of particels',
      'quicklocate_tip': "Tip: Click the image below to quickly locate!",
      'build_detail_back': 'Back',
      'build_detail_next': 'Next',

      // main page
      'main_products' : 'Product',
      'main_Unique_title' : 'Pixel Artistic',
      'main_Unique_detail' : 'Transform your photos into enduring masterpieces. Creativity and diversity have no bounds in art. At Amalia, each picture narrates a unique story, transcending age. Choose the pixel artistic journey with Amalia, where every image becomes a timeless work of art.',

      'main_try_upload' : 'Try it now',
      'main_try_upload_detail' : 'Upload your photo and create your very own pixel art masterpiece!',
      'product_try_upload' : 'Try with portrait',
      'product_try_upload_detail' : 'Upload your photo, especially a single human face, and create your very own pixel art masterpiece!',
      'main_bottom_text' : 'Try it now',
      'main_upload_wait_few_seconds' : 'Wait a few seconds...',
      
      'shop_on_amazon' : 'Shop On Amazon',

      'menu_about_us'  : 'About Us',
      'menu_home' : 'Home',
      'menu_products' : 'Products',

      'about_us_detail' : 'Amalia begins with a dedicated exploration of a unique artistic experience. We pursue not just products but an adventure in creativity, fashion, and the fusion of diverse cultures. From the initial inspiration to the clever design of our products, Amalia tirelessly seeks the beauty of art beyond the ordinary. Our mission is to break boundaries and create a unique artistic space for individuals of every age. Whether transforming photos into pixel art, diamond paintings, or assembling masterpieces with building blocks, Amalia consistently leads the trend of creativity, making every moment an eternal piece of art. Choose Amalia for a distinct artistic journey.',
      'about_us_title' : 'The story of Amalia',

      'littlebrick_showname' : Product_Info.Origin.show_name,
      'microbrick_showname' : Product_Info.MicroBrick.show_name,
      'colorbrick_gray_showname' : Product_Info.Memory.show_name,
      'colorbrick_orange_showname' : Product_Info.Energetic.show_name,
      'colorbrick_pink_showname' : Product_Info.Fascinatic.show_name,
      'fusebeads_showname' : Product_Info.FuseBeads.show_name,
      'diamondpainting_showname' : Product_Info.DiamondPainting.show_name,
      'romantic_showname' : Product_Info.Romantic.show_name,
      'warmth_showname' : Product_Info.Warmth.show_name,

      'use_granules' : 'This artwork uses the following granules or beads:',


      // product introduction
      'littlebrick_introduction' : 'Using a single baseplate and distinct black-and-white bricks, create your own unique mosaic portrait inspired by primitive art![A 50x50 studs baseplate;Black, white, gray and dark gray square bricks]',
      'microbrick_introduction' : 'Craft a new trend in desktop art with 4mm bricks![A 50x50-studs orange baseplate;4mm light-fresh, fresh, brown and black square bricks]',
      'colorbrick_gray_introduction' : 'The faded black-and-white mosaic portrait evokes endless memories[Nine 16x16-studs connectable baseplates;Black, white, gray and yellow round tile bricks]',
      'colorbrick_orange_introduction' : 'The vibrant hues of red, orange, and yellow bring you boundless energy[Nine 16x16-studs connectable baseplates;Red, orange, yellow, black and white round tile bricks]',
      'colorbrick_pink_introduction' : 'Experience an elegant, intellectual, and relaxed portrait, adding a touch of charm to your living space[Nine 16x16-studs connectable baseplates;Pink, fresh, blue, black and white round tile bricks]',
      'fusebeads_introduction' : 'Simple fuse beads, easy cartoon portraits, unleash endless creativity![20 colors of fuse beads;4 auxiliary pegboards for assembly]',
      'diamondpainting_introduction' : 'Rich colors, realistic details, and an oil painting style—make your artwork truly exceptional[47 colors of round diamond beads;A 30x30-inch or 40x50-inch canvas]',
      'romantic_introduction' : 'A heart-shaped love, a stroke of rainbow, a couple of lovers - embark on a romantic journey[Sixteen 16x16-studs connectable baseplates;Red, yellow, gray, green, black and white round plate bricks]',

      'product_part_titile' : 'Assembled from the following parts:',

      // pdf email
      'pdf_dialog_tile' : 'Download PDF',
      'pdf_email_blank': 'Please enter your email address!',
      'pdf_email_invalid': 'Please enter a valid email address!',
      'pdf_email_send': 'The instructions are being prepared, and will be sent to your email in a few minutes.',
      'pdf_input_dict': 'Email address',
      'pdf_sender': 'Please enter your email address, and the assembly instructions will be sent to your email in pdf format.',


      // particle
      'particle_warning': 'The following color(s) in the selected pattern exceed the maximum allowed quantity. Please choose a different pattern or upload a new picture.',
      'particle_color': 'Color',
      'particle_quantity_provided': 'Quantity Provided',
      'particle_quantity_need': 'Quantity Needed',


      // 通用
      'general_confirm': 'Confirm',
      'general_cancel': 'Cancel',

      
    }
  }
export default en
  